type SortableItem = {
  familiarityScore?: {
    rating: number;
    score: number;
  } | null;
  name?: string;
};

const sortByScoreAndName = (a?: SortableItem | null, b?: SortableItem | null): number => {
  const ratingDifference = (b?.familiarityScore?.rating ?? 0) - (a?.familiarityScore?.rating ?? 0);

  if (ratingDifference !== 0) {
    return ratingDifference;
  }
  const scoreDifference = (b?.familiarityScore?.score ?? 0) - (a?.familiarityScore?.score ?? 0);

  if (scoreDifference !== 0) {
    return scoreDifference;
  }

  return (a?.name ?? '').localeCompare(b?.name ?? '');
};

export default sortByScoreAndName;
